import { h } from 'preact'

import { IconComponentProps } from './index'

const DescriptionIcon = ({ width = 24, height = 24, color = 'currentColor', customClass = '' }: IconComponentProps) => (
  <svg width={width} height={height} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' className={customClass}>
    <path d='M16 16H0V18.6667H16V16ZM16 5.33333H0V8H16V5.33333ZM0 13.3333H24V10.6667H0V13.3333ZM0 24H24V21.3333H0V24ZM0 0V2.66667H24V0H0Z' fill={color} />
  </svg>
)

export default DescriptionIcon
